import React from "react";
import { styled } from "@mui/system";
import MUIAlert from "@mui/material/Alert";
import { AlertProps as AlertPropsMUI } from "@mui/material/Alert";
export interface AlertProps extends AlertPropsMUI {
  component?: React.ElementType;
}

export const Alert: (props: AlertProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
    <MUIAlert ref={ref} {...props} />
  )),
  {
    name: "Alert",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiAlert-root": {
    ...theme.typography["body"],
    // boxShadow: theme.shadows[5],
    fontSize: 14,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 3.5,
    paddingBottom: 3.5,
    "& .MuiAlert-message": {
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 0,
      paddingRight: 0,
      width: "100%"
    },
    "& .MuiAlert-icon": {
      fontSize: 18,
      paddingTop: 8
    },
    "& .MuiAlert-action .MuiButtonBase-root .MuiSvgIcon-root": {
      color: theme.palette.primary.iconDefault
    }
  },
  "&.MuiAlert-outlinedError": {
    border: "1px solid" + theme.palette.primary.baseCriticalColor,
    borderBottom: "4px solid" + theme.palette.primary.baseCriticalColor,
    "& .MuiAlert-icon": {
      color: theme.palette.primary.baseCriticalColor
    }
  },
  "&.MuiAlert-outlinedInfo": {
    border: "1px solid" + theme.palette.primary.baseInfoColor,
    borderBottom: "4px solid" + theme.palette.primary.baseInfoColor,
    "& .MuiAlert-icon": {
      color: theme.palette.primary.baseInfoColor
    }
  },
  "&.MuiAlert-outlinedSuccess": {
    border: "1px solid" + theme.palette.primary.borderSuccessed,
    borderBottom: "4px solid" + theme.palette.primary.borderSuccessed,
    "& .MuiAlert-icon": {
      color: theme.palette.primary.borderSuccessed
    }
  },
  "&.MuiAlert-outlinedWarning": {
    border: "1px solid" + theme.palette.primary.baseWarningColor,
    borderBottom: "4px solid" + theme.palette.primary.baseWarningColor,
    "& .MuiAlert-icon": {
      color: theme.palette.primary.baseWarningColor
    }
  },
  "&.MuiAlert-standardError": {
    "& .MuiAlert-icon": {
      color: theme.palette.primary.baseCriticalColor
    }
  },
  "&.MuiAlert-standardSuccess": {
    "& .MuiAlert-icon": {
      color: theme.palette.primary.borderSuccessed
    }
  },
  "&.MuiAlert-standardInfo": {
    "& .MuiAlert-icon": {
      color: theme.palette.primary.baseInfoColor
    }
  },
  "&.MuiAlert-standardWarning": {
    "& .MuiAlert-icon": {
      color: theme.palette.primary.baseWarningColor
    }
  },
  "&.MuiAlert-filledInfo": {
    "&.MuiAlert-root.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded": {
      color: theme.palette.primary.baseWhiteColor,
      background: theme.palette.primary.baseInfoColor
    }
  },
  "&.MuiAlert-filledError": {
    "&.MuiAlert-root.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded": {
      color: theme.palette.primary.baseWhiteColor,
      background: theme.palette.primary.baseCriticalColor
    }
  },
  "&.MuiAlert-filledSuccess": {
    "&.MuiAlert-root.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded": {
      color: theme.palette.primary.baseWhiteColor,
      background: theme.palette.primary.borderSuccessed
    }
  },
  "&.MuiAlert-filledWarning": {
    "&.MuiAlert-root.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded": {
      color: theme.palette.primary.baseWhiteColor,
      background: theme.palette.primary.baseWarningColor
    }
  }
}));
